import isEmpty from "is-empty";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { ReactMultiEmail } from "react-multi-email";
import { isEmailValid } from "src/utils/validators";

import "react-multi-email/dist/style.css";
import styles from "./styles.module.scss";

export const MultiEmailsRenderer = ({ value }) => {
    return isEmpty(value) ? null : (
        <ReactMultiEmail
            emails={value}
            className={styles.multiEmails}
            inputClassName={styles.inputDisabled}
            getLabel={(email, index) => (
                <div data-tag key={index}>
                    <div data-tag-item>{email}</div>
                </div>
            )}
        />
    );
};

export const MultiEmailsEditor = forwardRef((props, ref) => {
    const [value, setValue] = useState(props.value);
    const [isEditing, setIsEditing] = useState(false);
    const [tempValue, setTempValue] = useState("");

    useImperativeHandle(ref, () => ({
        getValue() {
            if (isEditing && isEmailValid(tempValue?.toLocaleLowerCase()))
                return [...value, tempValue];
            return value;
        },

        isCancelBeforeStart() {
            return false;
        },

        isCancelAfterEnd() {
            return false;
        },
    }));

    return (
        <ReactMultiEmail
            emails={value}
            autoFocus={true}
            className={styles.multiEmails}
            inputClassName={styles.inputAllowed}
            onChange={(e) => {
                // when new valid email is added or removed
                setValue(e);
                setTempValue("");
                setIsEditing(false);
            }}
            onChangeInput={(e) => {
                // when a new email is being typed
                setTempValue(e);
                if (isEmpty(e)) {
                    setIsEditing(false);
                } else {
                    setIsEditing(true);
                }
            }}
            getLabel={(email, index, removeEmail) => (
                <div data-tag key={index}>
                    <div data-tag-item>{email}</div>
                    <span data-tag-handle onClick={() => removeEmail(index)}>
                        ×
                    </span>
                </div>
            )}
        />
    );
});
